/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachmentCreation } from '../models/AttachmentCreation';
import type { AttachmentListing } from '../models/AttachmentListing';
import type { AttachmentRetrieval } from '../models/AttachmentRetrieval';
import type { AttachmentUpdate } from '../models/AttachmentUpdate';
import { request as __request } from '../core/request';

export class AttachmentsService {

    /**
     * List attachments
     * @returns any
     * @throws ApiError
     */
    public static async listAttachments({
        uuid,
        page,
        pageSize,
    }: {
        uuid?: Array<string>,
        /** A page number within the paginated result set. **/
        page?: number,
        /** Number of results to return per page. **/
        pageSize?: number,
    }): Promise<{
        count: number,
        next?: string | null,
        previous?: string | null,
        results: Array<AttachmentListing>,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/attachments/`,
            query: {
                'uuid': uuid,
                'page': page,
                'page_size': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Create a new attachment object
     * @returns AttachmentCreation
     * @throws ApiError
     */
    public static async createAttachment({
        data,
    }: {
        data: AttachmentCreation,
    }): Promise<AttachmentCreation> {
        const result = await __request({
            method: 'POST',
            path: `/attachments/`,
            body: data,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Get the details of a single attachment
     * @returns AttachmentRetrieval
     * @throws ApiError
     */
    public static async getAttachment({
        uuid,
    }: {
        /** A UUID string identifying this attachment. **/
        uuid: string,
    }): Promise<AttachmentRetrieval> {
        const result = await __request({
            method: 'GET',
            path: `/attachments/${uuid}/`,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Replace the specified attachment
     * @returns AttachmentUpdate
     * @throws ApiError
     */
    public static async updateAttachment({
        uuid,
        data,
    }: {
        /** A UUID string identifying this attachment. **/
        uuid: string,
        data: AttachmentUpdate,
    }): Promise<AttachmentUpdate> {
        const result = await __request({
            method: 'PUT',
            path: `/attachments/${uuid}/`,
            body: data,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Partially update the specified attachment
     * @returns AttachmentUpdate
     * @throws ApiError
     */
    public static async partialUpdateAttachment({
        uuid,
        data,
    }: {
        /** A UUID string identifying this attachment. **/
        uuid: string,
        data: AttachmentUpdate,
    }): Promise<AttachmentUpdate> {
        const result = await __request({
            method: 'PATCH',
            path: `/attachments/${uuid}/`,
            body: data,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * Delete the specified attachment
     * @returns void
     * @throws ApiError
     */
    public static async destroyAttachment({
        uuid,
    }: {
        /** A UUID string identifying this attachment. **/
        uuid: string,
    }): Promise<void> {
        const result = await __request({
            method: 'DELETE',
            path: `/attachments/${uuid}/`,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

}